import React, { useEffect, useState } from "react";

import "./Header.css";
import { ArrowRight } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

import LoginSignupModal from "../LoginSignupModal/LoginSignupModal";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import LazyLoad from "react-lazy-load";
let headerLogo = "https://rr-media-files.s3.ap-south-1.amazonaws.com/HomeSlideImages/assets/Images/RRPL.jpeg";
let headerSearchIcon = "https://d2s80gmgq3vhu4.cloudfront.net/HomeSlideImages/assets/Images/headerSearchIcon.png";
let headerHam = "https://d2s80gmgq3vhu4.cloudfront.net/HomeSlideImages/assets/Images/headerHam.png";
let crossClose = "https://d2s80gmgq3vhu4.cloudfront.net/HomeSlideImages/assets/Images/crossClose.png";

function Header() {
  const [sidePanelRight, setSidePanelRight] = useState({ width: "0px" });
  const [sidePanelTop, setSidePanelTop] = useState({ width: "0px" });
  const [topPanelServices, setTopPanelServices] = useState({ height: "0px" });
  const [topPanelAboutUs, setTopPanelAboutUs] = useState({ height: "0px" });
  const [topPanelInsights, setTopPanelInsights] = useState({ height: "0px" });
  const [modalShow, setModalShow] = useState(false);

  const toggleRightPanel = () => {
    setTopPanelServices({ height: "0px" });
    setTopPanelAboutUs({ height: "0px" });
    setTopPanelInsights({ height: "0px" });
    if (sidePanelRight.width == "0px") {
      setSidePanelRight({ width: "472px" });
    } else {
      setSidePanelRight({ width: "0px" });
    }
  };

  const toggleTopPanelServices = () => {
    setSidePanelRight({ width: "0px" });
    setTopPanelAboutUs({ height: "0px" });
    setTopPanelInsights({ height: "0px" });
    if (topPanelServices.height == "0px") {
      setTopPanelServices({ height: "400px" });
    } else {
      setTopPanelServices({ height: "0px" });
    }
  };

  const toggleTopPanelAboutUs = () => {
    setSidePanelRight({ width: "0px" });
    setTopPanelServices({ height: "0px" });
    setTopPanelInsights({ height: "0px" });
    if (topPanelAboutUs.height == "0px") {
      setTopPanelAboutUs({ height: "400px" });
    } else {
      setTopPanelAboutUs({ height: "0px" });
    }
  };

  const toggleTopPanelInsights = () => {
    setSidePanelRight({ width: "0px" });
    setTopPanelServices({ height: "0px" });
    setTopPanelAboutUs({ height: "0px" });
    if (topPanelInsights.height == "0px") {
      setTopPanelInsights({ height: "400px" });
    } else {
      setTopPanelInsights({ height: "0px" });
    }
  };

  const openModel = () => {
    setSidePanelRight({ width: "0px" });
    setModalShow(true);
  };

  const [user, setUser] = useState([]);
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("userRR")));
  }, []);

  return (
    <div>
      <div style={sidePanelRight} className="sidepanel page-noice-bg">
        <div className="mv-topnav">
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography
                style={{
                  fontWeight: 10,
                }}
              >
                <h2 className="tp-l-heading large-heading ">Our Services</h2>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <h2 className="tp-l-heading large-heading ">Our Services</h2>
                <p className="small-text theme-grey-text mv-small-text">
                  We help businesses small and big, to find, lease and occupy
                  properties for the different needs that they have. We are
                  Realistic Realtors.
                </p>
                <Link
                  to="/clients"
                  className="small-text theme-voilet-text mv-small-text"
                ></Link>
                <div className="tp-r-container">
                  <div className="tp-r-links-contianer">
                    <Link to="/services" className="link-container">
                      services
                    </Link>
                    <Link to="/CorporateService" className="link-container">
                      Corporate services
                    </Link>
                    <Link to="/RetailServices" className="link-container">
                      Retail services
                    </Link>
                    <Link to="/" className="link-container">
                      Warehouse services
                    </Link>
                    <Link to="/InteriorManagement" className="link-container">
                      Interior Management
                    </Link>
                  </div>
                  <div className="tp-r-links-contianer">
                    <Link to="/InvestmentAdvisory" className="link-container">
                      Investment Advisory
                    </Link>
                    <Link to="/" className="link-container">
                      Corporate services
                    </Link>
                    <Link to="/RetailServices" className="link-container">
                      Retail services
                    </Link>
                  </div>
                </div>
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography
                style={{
                  fontWeight: 10,
                }}
              >
                <Link className="header-link" to="/mandated-properties-results">
                  <h3 className="tp-l-heading large-heading ">Properties</h3>
                </Link>
              </Typography>
            </AccordionSummary>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography
                style={{
                  fontWeight: 10,
                }}
              >
                <h3 className="tp-l-heading large-heading ">Insights</h3>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <div className="tp-contianer">
                  <div className="tp-l-container">
                    <h3 className="tp-l-heading large-heading">Insights</h3>
                    <p className="small-text theme-grey-text mv-small-text">
                      We help businesses small and big, to find, lease and
                      occupy properties for the different needs that they have.
                      We are Realistic Realtors.
                    </p>
                    <Link
                      to="/clients"
                      className="small-text theme-voilet-text mv-small-text"
                    ></Link>
                  </div>
                  <div className="tp-r-container">
                    <div className="tp-r-links-contianer">
                      <Link to="/articles" className="link-container">
                        Articles
                      </Link>
                      <Link to="/" className="link-container">
                        Case Studies
                      </Link>

                      <Link to="/" className="link-container">
                        Media Coverage
                      </Link>
                      <Link to="/" className="link-container">
                        CSR
                      </Link>
                    </div>
                  </div>
                </div>
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
        {/* <div className="right-panel-container">
          <div className="r-p-acc-container">
            {user ? (
              <h3 className="r-p-acc-heading"> Welcome </h3>
            ) : (
              <h3 className="r-p-acc-heading">Have an accout?</h3>
            )}

            <p className="r-p-acc-content">
              Log in to save properties track listing requests and more.
            </p>

            {user ? (
              <a href="/account">
                <p className="r-p-acc-content theme-voilet-text r-p-acc-b-link">
                  Go to account <ArrowRight />
                </p>
              </a>
            ) : (
              <p
                onClick={openModel}
                className="r-p-acc-content theme-voilet-text r-p-acc-b-link"
              >
                Log in <ArrowRight />
              </p>
            )}
          </div>
          <div className="r-p-links-continaer">
            <a className="r-p-link" href="/career">
              Careers
            </a>
            <a className="r-p-link" href="/search">
              List your Requirement
            </a>
            <a className="r-p-link" href="/search">
              Properties
            </a>
            <a className="r-p-link" href="/privacypolicy">
              Privacy Policy
            </a>
            <a className="r-p-link" href="/Services">
              Insights
            </a>
          </div>
        </div> */}
      </div>

      <div style={topPanelServices} className="toppanel page-noice-bg">
        <div className="tp-contianer">
          <div className="tp-l-container">
            <h2 className="tp-l-heading large-heading ">Our Services</h2>
            <p className="small-text theme-grey-text">
              We help businesses small and big, to find, lease and occupy
              properties for the different needs that they have. We are
              Realistic Realtors.
            </p>
            <Link to="/clients" className="small-text theme-voilet-text"></Link>
          </div>
          <div className="tp-r-container">
            <div className="tp-r-links-contianer">
              <Link to="/CorporateService" className="link-container">
                Corporate Leasing
              </Link>
              <Link to="/RetailServices" className="link-container">
                Retail services
              </Link>
              <Link to="/WarehousesServices" className="link-container">
                Warehouse services
              </Link>
              <Link to="/InvestmentAdvisory" className="link-container">
                Investment Advisory
              </Link>
              <Link to="/InteriorManagement" className="link-container">
                Interior Management
              </Link>
            </div>
            <div className="tp-r-links-contianer">
              <Link to="/Propertiesforsale" className="link-container">
                Properties for sale
              </Link>
              <Link to="/Propertiesforlease" className="link-container">
                Properties for lease
              </Link>
              <Link to="/form" className="link-container">
                List your Requirement
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div style={topPanelAboutUs} className="toppanel page-noice-bg">
        <div className="tp-contianer">
          <div className="tp-l-container">
            <h2 className="tp-l-heading large-heading "> About us</h2>
            <p className="small-text theme-grey-text">
              We help businesses small and big, to find, lease and occupy
              properties for the different needs that they have. We are
              Realistic Realtors.
            </p>
            <Link to="/clients" className="small-text theme-voilet-text"></Link>
          </div>
          <div className="tp-r-container">
            <div className="tp-r-links-contianer">
              <Link to="/aboutus" className="link-container">
                About Us
              </Link>
              <Link to="/teams" className="link-container">
                Our Team
              </Link>
              {/* <a href="/aboutus" className="link-container">
                Vision & Mission
              </a> */}
              <Link to="/contactus" className="link-container">
                Contact us
              </Link>
            </div>

          </div>
        </div>
      </div>

      <div style={topPanelInsights} className="toppanel page-noice-bg">
        <div className="tp-contianer">
          <div className="tp-l-container">
            <span className="tp-l-heading large-heading ">Insights</span>
            <p className="small-text theme-grey-text">
              We help businesses small and big, to find, lease and occupy
              properties for the different needs that they have. We are
              Realistic Realtors.
            </p>
            <Link to="/clients" className="small-text theme-voilet-text"></Link>
          </div>
          <div className="tp-r-container">
            <div className="tp-r-links-contianer">
              <Link to="/articles" className="link-container">
                Articles
              </Link>
              <Link to="/articles" className="link-container">
                Case Studies
              </Link>

              <Link to="/newsroom" className="link-container">
                Media Coverage
              </Link>
              <Link to="/csr" className="link-container">
                CSR
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="header-contianer">
        <div className="header-links-contianer">
          <p
            onClick={() => toggleTopPanelServices()}
            className="header-link"
          >
            Services
          </p>
          <p className="header-link">
            <Link className="header-link" to="/mandated-properties">
              Properties
            </Link>
          </p>
          <p
            className="header-link"
            onClick={() => toggleTopPanelInsights()}
          >
            Insights
          </p>
        </div>

        <Link to="/">
          <img
            className="header-logo-image"
            alt="header-logo"
            src={headerLogo}
          />
        </Link>


        <div className="header-links-contianer">

          <p
            className="header-link"
            onClick={() => toggleTopPanelAboutUs()}
          >
            About Us
          </p>
          <LazyLoad>
            <Link className="header-link" to="/search">
              <img alt="search-icon" src={headerSearchIcon} />
            </Link>


            {sidePanelRight.width == "0px" ? (
              <img
                className="ham-icon"
                onClick={() => toggleRightPanel()}
                alt="ham-icon"
                src={headerHam}
              />
            ) : (
              <img
                className="ham-icon"
                onClick={() => toggleRightPanel()}
                alt="ham-icon"
                src={crossClose}
              />
            )}
          </LazyLoad>
        </div>
      </div>

      <div className="mv-header-contianer">
        <div className="mv-header-links-contianer links-item">
          <p
            onClick={() => toggleTopPanelServices()}
            className="mv-header-link"
          >
            Services
          </p>
          <p className="mv-header-link">
            <Link className="mv-header-link" to="/mandated-properties-results">
              Properties
            </Link>
          </p>
          <p
            className="mv-header-link"
            onClick={() => toggleTopPanelInsights()}
          >
            Insights
          </p>
        </div>
        <LazyLoad>
          {sidePanelTop.width == "0px" ? (
            <img
              className="mv-ham-icon"
              onClick={() => toggleRightPanel()}
              alt="ham-icon"
              src={headerHam}
            />
          ) : (
            <img
              className="mv-ham-icon"
              onClick={() => toggleRightPanel()}
              alt="ham-icon"
              src={crossClose}
            />
          )}
          <Link to="/">
            <img
              className="mv-header-logo-image"
              alt="header-logo"
              src={headerLogo}
            />
          </Link>{" "}


          <div className="mv-header-links-contianer">
            <p
              className="mv-header-link links-item"
              onClick={() => toggleTopPanelAboutUs()}
            >
              About Us
            </p>
            <Link className="mv-header-link" to="/search">
              <img alt="search-icon" src={headerSearchIcon} />
            </Link>
          </div>
        </LazyLoad>
      </div>
      <LoginSignupModal show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
}

export default Header;
